const MONGO_OBJECTID_HEX = /^[a-fA-F0-9]{24}$/

/** Normalize a single Mongo id value (building slot `data._id`, etc.). */
export function mongoIdFromValue(v: unknown): string {
  if (v === null || v === undefined || v === '') return ''
  if (typeof v === 'string' || typeof v === 'number') {
    const s = String(v).trim()
    return MONGO_OBJECTID_HEX.test(s) ? s : ''
  }
  if (typeof v === 'object') {
    const oid = (v as { $oid?: unknown }).$oid
    if (typeof oid === 'string' && MONGO_OBJECTID_HEX.test(oid)) return oid
    const toHex = (v as { toHexString?: () => string }).toHexString
    if (typeof toHex === 'function') {
      try {
        const h = toHex.call(v)
        return typeof h === 'string' && MONGO_OBJECTID_HEX.test(h) ? h : ''
      } catch {
        return ''
      }
    }
  }
  return ''
}

/** Character / worker row from inventory — uses `_id` or `id`. */
export function characterInstanceMongoId(
  row: { _id?: unknown; id?: unknown } | null | undefined,
): string {
  return mongoIdFromValue(row?._id ?? row?.id)
}

export function isLikelyReactSyntheticEvent(o: unknown): boolean {
  return typeof o === 'object' && o !== null && 'nativeEvent' in (o as object)
}
